import { NotificationsResponseInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const getNotifications: (url?: string) => Promise<NotificationsResponseInterface>
= (url?: string): Promise<NotificationsResponseInterface> => api.get(url ?? '/notifications');

export const markNotificationAsRead: (id: number) => Promise<void> = (id: number): Promise<void> => api.post(`/notifications/${id}/read`);

export const deleteNotification: (id: number) => Promise<void> = (id: number): Promise<void> => api.delete(`/notifications/${id}`);
